import { FC } from "react";

export const NoOtherClientAdminsNotice: FC = () => (
    <>
        <p>
            You can't transfer billing ownership because the client has no other
            users with Administrator access.
        </p>
        <p>
            Invite another admin user or promote an existing user to admin role
            first.
        </p>
    </>
);
